import { render, staticRenderFns } from "./DashboardInfoTile.vue?vue&type=template&id=05b55da6&scoped=true&"
import script from "./DashboardInfoTile.vue?vue&type=script&lang=js&"
export * from "./DashboardInfoTile.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInfoTile.vue?vue&type=style&index=0&id=05b55da6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b55da6",
  null
  
)

export default component.exports